"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Utils = void 0;
var Utils = /** @class */ (function () {
    function Utils() {
    }
    Utils.buildRequestURL = function (url, params) {
        if (!params)
            return url;
        var esc = encodeURIComponent;
        var query = Object.keys(params)
            .map(function (k) { return esc(k) + '=' + esc(params[k]); })
            .join('&');
        if (!query)
            return url;
        return url + (url.indexOf('?') !== -1 ? '&' + query : '?' + query);
    };
    Utils.getProtocol = function (ssl) {
        return ssl === false ? 'http://' : 'https://';
    };
    return Utils;
}());
exports.Utils = Utils;
